import { render, staticRenderFns } from "./AdminManagementAdmins.vue?vue&type=template&id=971aa240&scoped=true&"
import script from "./AdminManagementAdmins.vue?vue&type=script&lang=js&"
export * from "./AdminManagementAdmins.vue?vue&type=script&lang=js&"
import style0 from "./AdminManagementAdmins.vue?vue&type=style&index=0&id=971aa240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971aa240",
  null
  
)

export default component.exports